module.exports = __webpack_public_path__ + "img/night_rocks.88fceaab.jpg";